import * as DictionaryConstants from '../../../../../../constants/DictionaryConstants'
import * as RoutePathConstants from '../../../../../../constants/RoutePathConstants'

export default {
  data () {
    return {

    }
  },
  methods: {
    gotoPersonalInformation () {
      this.$router.push({
        path: RoutePathConstants.PERSONAL_INFORMATION
      })
    }
  },
  mounted () {

  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/page-mail-my/views/my-set-up/my-set-up.js